<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
    <template #item.manufacturerType="{item}">
      {{ formatManufacturerType(item.manufacturerType) }}
    </template>
  </entity-list-table>
</template>

<script>
  import OrganizationDataService from '@/services/api/OrganizationDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'
  import TechnicalCardDataService from '@/services/api/TechnicalCardDataService'
  import ManufacturerType from '@/models/enums/ManufacturerType'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Технические карты',
        dataService: TechnicalCardDataService,
        createRouteName: 'technicalCardCreate',
        editRouteName: 'technicalCardEdit',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Вес', value: 'weight', align: 'start' },
          { text: 'Белки', value: 'proteins', align: 'start' },
          { text: 'Жиры', value: 'fats', align: 'start' },
          { text: 'Углеводы', value: 'carbohydrates', align: 'start' },
          { text: 'Калорийность', value: 'calories', align: 'start' },
          { text: 'Кто готовит', value: 'manufacturerType', align: 'start' },
        ],
        allowDelete: false,
        showStatusColumn: false,
      }
    },
    methods: {
      formatManufacturerType (value) {
        return ManufacturerType.getName(value)
      },
    },
  }
</script>
